import { render, staticRenderFns } from "./BasicUserDashboard.vue?vue&type=template&id=41a003f9&scoped=true"
import script from "./BasicUserDashboard.vue?vue&type=script&lang=js"
export * from "./BasicUserDashboard.vue?vue&type=script&lang=js"
import style0 from "./BasicUserDashboard.vue?vue&type=style&index=0&id=41a003f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a003f9",
  null
  
)

export default component.exports